module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/16lPxRR/d2d_images/cover.jpg?1720280630595",
      "alt": "This image is the cover for the book Da Zero a Sexy"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Da Zero a Sexy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Dal momento che Santana si nasconde da qualcosa di brutto appartenente al suo passato, vive giorno per giorno e non osa sognare un futuro. La sua vita si svolge solo all’interno del sensuale mondo di Kidnap Fantasies, una società di escort top-secret in cui esplora la propria sessualità e gode del piacere sia con uomini che con donne."), _c('br'), _vm._v(" Ma è amore a prima vista nel momento in cui vede Amy al matrimonio di un suo caro amico. La ragazza sa di futuro ma lui è consapevole che quello è un desiderio che deve negarsi; quindi, perché le sussurra"), _c('i', [_vm._v("sei mia")]), _vm._v("?"), _c('br'), _vm._v(" Nell’istante in cui Amy Sparks vede il bell’afroamericano al matrimonio di sua sorella, sa in cuor suo che lui è tutto ciò che ha sempre sognato in un amante, ma prima che possano conoscersi meglio, lui scompare misteriosamente."), _c('br'), _vm._v(" Dopo aver scoperto che lavora per la Kidnap Fantasies, Amy saprà come lui riuscirà ad avverare tutte le sue intime fantasie..."), _c('br'), _vm._v(" E quando Santana scoprirà che la sua prossima cliente della Kidnap Fantasies è Amy, saprà anche di doverla proteggere dal suo passato consapevole che quell’esperienza intima tra loro non potrà ripetersi..."), _c('br')]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jan Springer, Arianna Giorgi\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Jan Springer vive a Minden Hills, Ontario, Canada. Scrive a tempo pieno e le piace andare in kayak, è appassionata di fotografia, escursionismo, lettura e scrittura. E' un membro del Romance Writers of America e del Writers's Union of Canada."), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Spunky Girl Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0